import {
  apiRequest,
  requestRefresh,
  type ApiRequestMethod,
  type ApiRequestOptions,
} from '@codestreet/api'

import { env } from '@/shared/config'

import { emitError } from './responseParser'

export async function useApiAuth<R>(
  path: string,
  method: ApiRequestMethod = 'GET',
  body?: any,
  requestOptions?: ApiRequestOptions,
) {
  const requestURL = new URL(env.AUTH_URL + path)
  const options = {
    webview: !!requestOptions?.webview,
  }
  const headers = {
    version_backend: env.VERSION_BACKEND,
    application: env.APPLICATION,
  }
  const response = await apiRequest<R>(requestURL, method, body, headers, options)
  return response
}

export async function useApiThread<R>(
  path: string,
  method: ApiRequestMethod = 'GET',
  body?: any,
  requestOptions?: ApiRequestOptions,
) {
  const requestURL = new URL(env.THREAD_URL + path)
  const options = {
    webview: !!requestOptions?.webview,
  }
  const headers = {
    version_backend: env.VERSION_BACKEND,
    application: env.APPLICATION,
  }
  let response = await apiRequest<R>(requestURL, method, body, headers, options)
  if (response.isAuthError && !options.webview) {
    const isRefresh = await requestRefresh(env.AUTH_URL, headers, options)
    if (!isRefresh) return response
    response = await apiRequest<R>(requestURL, method, body, headers, options)
  }
  emitError(response, requestURL.pathname)
  return response
}

export async function useApiApp<R>(
  path: string,
  method: ApiRequestMethod = 'GET',
  body?: any,
  requestOptions?: ApiRequestOptions,
) {
  const requestURL = new URL(env.APP_URL + path)
  const options = {
    webview: !!requestOptions?.webview,
  }
  const headers = {
    version_backend: env.VERSION_BACKEND,
    application: env.APPLICATION,
  }
  let response = await apiRequest<R>(requestURL, method, body, headers, options)
  if (response.isAuthError) {
    const isRefresh = await requestRefresh(env.AUTH_URL, headers, options)
    if (!isRefresh) return
    const requestURL = new URL(env.APP_URL + path)
    response = await apiRequest<R>(requestURL, method, body, headers, options)
  }
  emitError(response, requestURL.pathname)
  return response
}

export async function useApiTrack<R>(
  path: string,
  method: ApiRequestMethod = 'GET',
  body?: any,
  requestOptions?: ApiRequestOptions,
) {
  const requestURL = new URL(env.TRACK_URL + path)
  const options = {
    webview: !!requestOptions?.webview,
  }
  const headers = {
    version_backend: env.VERSION_BACKEND,
    application: env.APPLICATION,
  }
  const response = await apiRequest<R>(requestURL, method, body, headers, options)
  return response
}
